import {
  Directive,
  ElementRef,
  AfterViewInit,
  HostListener,
  Renderer2,
} from '@angular/core';
import { Tooltip } from 'primeng/tooltip';

@Directive({ standalone: false,
  selector: '[mxEllipsis]',
})
export class MxEllipsisDirective implements AfterViewInit {
  domElement: any;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    this.domElement = this.elementRef.nativeElement;

    const ellipsis: any = {
      'text-overflow': 'ellipsis',
      overflow: 'hidden',
      'white-space': 'nowrap',
    };
    Object.keys(ellipsis).forEach((element) => {
      this.renderer.setStyle(this.domElement, `${element}`, ellipsis[element]);
    });
  }

  ngAfterViewInit(): void {
    this.renderer.setProperty(this.domElement, 'scrollTop', 1);
    this.setToolTip();
  }

  @HostListener('window:resize', ['$event.target'])
  setToolTip() {
    this.domElement.offsetWidth < this.domElement.scrollWidth
      ? this.renderer.setAttribute(
          this.domElement,
          'title',
          this.domElement.textContent
        )
      : this.renderer.removeAttribute(this.domElement, 'title');
  }
}
